var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeMacaron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 76 150",
    style: {
      enableBackground: "new 0 0 76 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:none;stroke-width:3;stroke-linecap:round}")), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -8.7,
    y: -3.1,
    width: 71.5,
    height: 156.2,
    id: "mask0_611_1793_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150h.8C42.3 150 76 116.4 76 75S42.3 0 .8 0H0v48.8h.8c14.5 0 26.3 11.8 26.3 26.3S15.3 101.4.8 101.4H0V150z",
    style: {
      fill: "#ffc220"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shape",
    fill: "#ffc220",
    d: "M0 150h.8C42.3 150 76 116.4 76 75S42.3 0 .8 0H0v48.8h.8c14.5 0 26.3 11.8 26.3 26.3S15.3 101.4.8 101.4H0V150z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask0_611_1793_2_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke st3",
    stroke: "currentColor",
    d: "M-2.4 151.6c.5-.9 1.6-1.8 2.4-2.5.2-.1.3-.3.5-.4 3.5-3.4 7.1-6.7 10.3-10.3 13.6-14.8 23.7-32.8 26.5-52 2.7-18.5-3-37.3-15.9-51.8C15 27.3 7.8 20.7 0 14.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke st3",
    stroke: "currentColor",
    d: "M-7.2-1.6c20.6 7.8 37.9 20.4 51.9 36.2C57.6 49.1 63.3 68 60.6 86.4c-2.8 19.2-12.9 37.2-26.6 52-3.3 3.6-6.8 6.9-10.3 10.3-.9.9-2.3 1.9-2.9 2.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeMacaron);
export default __webpack_public_path__ + "static/media/shape-macaron.25087901.svg";
export { ForwardRef as ReactComponent };